import { Fragment, useState } from 'react';

import { ThumbnailSelectModal } from '@playbooks/components/thumbnail/thumbnail-select-modal';
import { Button } from '@playbooks/ui/components/button';
import { FieldLabel } from '@playbooks/ui/components/field';
import { Icon } from '@playbooks/ui/components/icon';
import { cn } from '@playbooks/ui/lib/utils';

const ThumbnailBtn = ({ title, value, size = 'default', onChange, className = '' }) => {
	const [open, setOpen] = useState(false);

	// Methods
	const onOpen = () => setOpen(true);
	const onUpdate = value => {
		onChange(value);
		setOpen(false);
	};

	// Theme
	const rootClassName = cn('flex-start', size === 'sm' ? 'gap-3' : 'gap-8', className);
	const thumbnailClassName = cn(
		'aspect-[1/1] bg-surface-hover border rounded-control flex-middle overflow-hidden',
		size === 'sm' ? 'w-12' : 'w-20',
	);

	// Render
	return (
		<Fragment>
			<div className={rootClassName}>
				<div className={thumbnailClassName}>
					{value ? (
						<img src={value} alt='' className='size-full object-cover' />
					) : (
						<Icon type='far' icon='cube' className='text-foreground-body' aria-hidden />
					)}
				</div>
				<div className='space-y-2'>
					<FieldLabel className={cn('block font-medium', size === 'sm' ? 'text-sm' : 'text-base')}>{title}</FieldLabel>
					<Button variant='outline' size='xs' onClick={onOpen}>
						Upload
					</Button>
				</div>
			</div>
			<ThumbnailSelectModal model={value} open={open} setOpen={setOpen} saveApi='' onNext={onUpdate} />
		</Fragment>
	);
};
export { ThumbnailBtn };
